import React, { useEffect, useState } from "react";
import Preloader from "../elements/Preloader";
import HelmetReact from "../elements/HelmetReact";
import HeaderTwo from "../components/HeaderTwo";
import HeroTwo from "../components/HeroTwo"; // Adicionado o import do HeroTwo
import AboutTwo from "../components/AboutTwo";
import ServiceThree from "../components/ServiceThree";
import WhyChoose from "../components/WhyChoose";
import TestimonialTwo from "../components/TestimonialTwo";
import FooterTwo from "../components/FooterTwo";
import ServiceOne from "../components/ServiceOne";
import FaqTwo from "../components/FaqTwo";

const Home = () => {
  let [active, setActive] = useState(true);
  
  useEffect(() => {
    setTimeout(function () {
      setActive(false);
    }, 500);
  }, []);

  return (
    <>

      {/* Helmet */}
      <HelmetReact title={"Home"} />

      {/* HeaderTwo */}
      <HeaderTwo />

      {/* HeroTwo */}
      <HeroTwo />

      {/* AboutTwo */}
      <AboutTwo />

      {/* ServiceThree */}
      <ServiceThree />

      {/* ServiceOne */}
      <ServiceOne />

      {/* FaqTwo */}
      <FaqTwo />

      {/* WhyChoose */}
      <div className="space-bottom">
        <WhyChoose />
      </div>

      {/* TestimonialTwo */}
      <TestimonialTwo />

      {/* FooterTwo */}
      <FooterTwo />
    </>
  );
};

export default Home;